import IncidentObserver from 'components/errors/IncidentObserver';
import ErrorBoundary from 'components/general/ErrorBoundary';
import { TooltipStyles } from 'components/tooltip/Tooltip';
import { FullScreenProvider } from 'context/FullScreen';
import { ProfilingProvider } from 'context/Profiling';
import { ReportingProvider } from 'context/ReportingContext';
import useCustomDomainManager from 'hooks/useCustomDomainManager';
import { AirmeetTranslationProvider } from 'hooks/useCustomTranslation';
import useLogWorkerManager from 'hooks/useLogWorkerManager';
import useTapfiliateClickScript from 'hooks/useTapfiliateClickScript';
import useVWO from 'hooks/useVWO';
import React, { Suspense } from 'react';
import { Router } from 'react-router-dom';
import 'styles/App.scss';
import 'styles/base.scss';
import AllInfoBanners from '../components/allInfoBanners';
import BestExperienceBrowser from '../components/general/BestExperienceBrowser';
import Loader from '../components/general/Loader';
import Page from '../components/general/Page';
import Toasts from '../components/general/Toasts';
import AppHeader from '../components/header';
import Footer from '../components/home/footer';
import AppModals from '../components/modals';
import SideMenu from '../components/sideMenu';
import history from '../history';
import useAuthManager from '../hooks/useAuthManager';
import useBeamerWidget from '../hooks/useBeamerWidget';
import Routes from '../route';
import '../styles/App.scss';
import '../styles/base.scss';

export default function App() {
    // Manage auth at app level
    useAuthManager();
    useLogWorkerManager();
    useBeamerWidget();
    useVWO();
    useTapfiliateClickScript();
    useCustomDomainManager();

    return (
        <ErrorBoundary>
            <ReportingProvider>
                <Suspense fallback={<Loader fullPage={true} type='logo' />}>
                    <ProfilingProvider
                        options={{
                            log: true,
                        }}
                    >
                        <AirmeetTranslationProvider>
                            <Router history={history}>
                                <BestExperienceBrowser />
                                <FullScreenProvider>
                                    <Toasts />
                                    <AllInfoBanners />
                                    <AppHeader />

                                    <div className='app-content'>
                                        <SideMenu />

                                        <Page>
                                            <Routes history={history} />
                                        </Page>
                                    </div>

                                    <Footer />

                                    <AppModals />
                                </FullScreenProvider>
                            </Router>
                        </AirmeetTranslationProvider>
                    </ProfilingProvider>
                </Suspense>
                <IncidentObserver />
                <TooltipStyles />
            </ReportingProvider>
        </ErrorBoundary>
    );
}
